import React, { Component } from 'react';
import { connect } from 'react-redux';
import { array } from 'prop-types';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import {
  startSetWallets,
  startCreateWallets,
  startDeleteWallets,
  startUpdateWallets,
} from '@actions/wallets';
import {
  startSetSlaveWallets,
  startCreateSlaveWallets,
  startDeleteSlaveWallets,
} from '@actions/slaves';
import { clearRedirectToPaymentsData } from '@actions/finances';
import WithAlert from '@hoc/WithAlert';
import { iFMessage } from '@hoc/IntlComponents';
import { getSlaveId } from '@components/Statistics/statisticsHelpers';
import SMSNotificationsModal from '@modals/SMSNotificationsModal/SMSNotificationsModal';
import PaymentPursesListWrapper from '@components/Payments/PaymentPursesListWrapper';
import Layout from '../../../../components/Layout/Layout';
import ProfileCard from '../../components/ProfileCard/ProfileCard';
import ProfileNav from '../../components/ProfileNav/ProfileNav';
import PaymentPursesNav from '../../components/Payments/PaymentPursesNav';
import { Col } from 'reactstrap';
import Card from '../../../../components/Card/Card';
import PaymentPursesList from '../../../../components/Payments/PaymentPursesList';

const walletsIds = {
  1: 'wmr',
  3: 'bank',
  4: 'yandex',
  5: 'qiwi',
  11: 'epayments',
  15: 'wmz',
  29: 'zaleycash',
  27: 'wme',
  30: 'bank',
  31: 'capitalist',
  32: 'capitalist_usd',
  33: 'capitalist_eur',
  34: 'entryprofit',
  35: 'viztrom',
  36: 'zaleycash_usd',
  37: 'bank',
};

const deafaultVerifiationData = {
  sessionId: 0,
  verification_error: null,
  status: null,
  validTill: 0,
  transport: 'sms',
};

class PaymentDataPage extends Component {
  static propTypes = {
    wallets: array.isRequired,
  };

  static defaultProps = {
    wallets: [],
  };

  state = {
    loading: false,
    modal: false,
    error: {},
    newWalletSMSInputTargetId: null,
    selectedWallet: 3,
    smsModal: false,
    sessionId: 0,
    verification_error: null,
    status: null,
    validTill: 0,

    changingInputId: null,
  };

  componentDidMount() {
    this.getWallets();
  }

  renderSuccessMessage = (type, action) => {
    const { intl } = this.props;
    const walletString = iFMessage({
      intl,
      id: `payment-data.wallets.update.success.${walletsIds[type]}`,
    });
    const actionString = iFMessage({
      intl,
      id: `payment-data.wallets.update.success.action.${action}`,
    });
    const disclaimerString =
      action === 'change'
        ? iFMessage({
            intl,
            id: `payment-data.wallets.update.success.disclaimer`,
            values: {
              hours: `<strong>${iFMessage({
                intl,
                id: 'payment-data.wallets.update.success.disclaimer.hours',
              })}</strong>`,
            },
          })
        : '';
    return `${walletString} ${actionString} ${disclaimerString}`;
  };

  getWallets = () => {
    const { isMember, startSetWallets, startSetSlaveWallets } = this.props;
    this.setState(() => ({ loading: true }));
    const request = !isMember ? startSetWallets : startSetSlaveWallets;
    request(getSlaveId())
      .catch(({ response = {} }) => {
        this.handleErrorAlerts(response);
      })
      .finally(() => this.setState(() => ({ loading: false })));
  };

  closeModal = () => {
    this.setState(() => ({ modal: false, error: {} }));
  };

  handleSave = data => {
    this.setState(() => ({ loading: true }));
    const { startCreateWallets, startCreateSlaveWallets, isMember, showAlert, intl } = this.props;
    const request = !isMember ? startCreateWallets : startCreateSlaveWallets;
    const params = { ...data };
    if (isMember) {
      params.id = getSlaveId();
    }

    request(params)
      .then(() => {
        showAlert({
          alertType: 'success',
          message: iFMessage({
            intl,
            id: `payment-data.create.success${data.type === 3 ? '.bank' : ''}`,
          }),
          dismissable: true,
          closeInSeconds: 3,
        });
        return this.getWallets();
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;

          this.setState(() => ({
            loading: false,
            modal: true,
            error,
          }));
        }
      });
  };

  handleDelete = (id, type) => {
    const { startDeleteWallets, startDeleteSlaveWallets, showAlert, intl, isMember } = this.props;
    const request = !isMember ? startDeleteWallets : startDeleteSlaveWallets;
    const params = { id };
    if (isMember) {
      params.slaveId = getSlaveId();
    }
    request(params)
      .then(() => {
        this.getWallets();
        showAlert({
          alertType: 'success',
          message: iFMessage({
            intl,
            id: `payment-data.delete.success${type === 3 ? '.bank' : ''}`,
          }),
          dismissable: true,
          closeInSeconds: 3,
        });
      })
      .catch(({ response = {} }) => {
        this.handleErrorAlerts(response);
      });
  };

  // handleEdit = (id, type, firstname, lastname) => {
  //   const { showAlert, intl, startUpdateWallets } = this.props;
  //   const params = { id, type, firstname, lastname, wallet_id: id };
  //   startUpdateWallets(params)
  //     .then(() => {
  //       this.getWallets();
  //       showAlert({
  //         alertType: 'success',
  //         message: iFMessage({
  //           intl,
  //           id: `payment-data.edit.success${type === 3 ? '.bank' : ''}`,
  //         }),
  //         dismissable: true,
  //         closeInSeconds: 3,
  //       });
  //     })
  //     .catch(({ response = {} }) => {
  //       this.handleErrorAlerts(response);
  //     });
  // };

  showAlertMessage = (message, params) =>
    this.props.showAlert({
      alertType: 'danger',
      message,
      dismissable: true,
      closeInSeconds: 3,
      ...params,
    });

  handleErrorAlerts = response => {
    if (response && response.data) {
      const { message: error } = response.data.error;

      if (error.type === 'api.security.not_verified') {
        this.setState(() => ({ verification_error: error.message }));
      } else if (error.type === 'api.security.phone_number') {
        this.showAlertMessage(error.message, {
          closeInSeconds: null,
          alertType: 'warning',
          redirectPath: '/profile/security',
        });
      } else if (
        error.type === 'api.security.attempts_are_over' ||
        error.type === 'api.wallets.duplicate'
      ) {
        this.closeSMSModal();
        this.showAlertMessage(error.message);
      } else {
        this.showAlertMessage(error.message);
      }
    }
  };

  getPropsWallets = () => {
    const {
      isMember,
      wallets: webmasterWallets,
      slaves: { wallets },
    } = this.props;
    if (!isMember) {
      return webmasterWallets;
    } else {
      return wallets;
    }
  };

  // ЗАХАРДКОЖЕН ФИЛЬТР ОТОБРАЖЕНИЯ КОШЕЛЬКОВ - потом переделать когда будет
  // новый метод получения кошельков для страницы PaymentsDataPage

  // 3 = Банковские карты
  // 4 = Яндекс.Деньги
  // 5 = Киви.Кошелек
  getEditableWallets = wallets => {
    // @see components/Payments/PaymentPursesList.js:20
    return wallets.filter(wallet => [1, 3, 4, 5, 11, 15, 28, 29, 30, 31, 27, 32, 33, 34, 35, 36, 37].includes(wallet.type));
  };

  handleChangeNewWalletSMSInputTargetId = (target, id) =>
    this.setState(() => ({
      newWalletSMSInputTargetId: target,
      changingInputId: id,
    }));

  submitCatchCB = () => {
    this.setState({
      error: false,
      newWalletSMSInputError: false,
    });
  };

  submitThenCB = () => {
    this.setState({
      newWalletSMSInputError: false,
      error: false,
      newWalletSMSInput: '',
      number: '',
    });
  };

  handleSubmitWithSMS = ({ submitData, code, submitCatchCB, submitThenCB }) => {
    const { showAlert, intl, startCreateWallets, startUpdateWallets } = this.props;

    let requestData;

    this.setState(
      () => ({
        submitData,
        submitCatchCB,
        submitThenCB,
      }),
      () => {
        const { sessionId, authType } = this.state;
        requestData = { ...submitData };
        if (authType) {
          switch (authType) {
            case 1:
              requestData['sms_session_id'] = sessionId;
              requestData['sms_code'] = code;
              break;
            case 2: // google auth
              requestData['token'] = code;
              break;
            case 4: // telegram bot
              requestData['telegram_code'] = code;
              requestData['telegram_session_id'] = sessionId;
              break;
          }
        } else if (sessionId && code) {
          requestData['verification_session_id'] = sessionId;
          requestData['verification_code'] = code;
        }
        const { wallet_id } = requestData;
        const request = wallet_id === null ? startCreateWallets : startUpdateWallets;
        const action = wallet_id === null ? 'add' : 'change';
        const { wallet_type } = requestData;
        const successMessage = this.renderSuccessMessage(wallet_type, action);
        request(requestData)
          .then(() => {
            this.handleSetVerificationData({
              sessionId: '',
              status: null,
              verification_error: null,
              changedWalletId: wallet_id,
              validTill: 0,
            });

            this.closeSMSModal();
            submitThenCB ? submitThenCB() : this.state.submitThenCB();
            this.handleChangeNewWalletSMSInputTargetId(null);
            showAlert({
              message: successMessage,
              alertType: 'success',
              closeInSeconds: null,
              dismissable: true,
            });
            this.getWallets();
          })
          .catch(err => {
            if (err && err.response) {
              const { response } = err.response.data;
              if (response) {
                if (err.response.status === 401) {
                  const { verification } = response;
                  const { sessionId, validTill, type, transport } = verification;

                  submitCatchCB ? submitCatchCB() : this.state.submitCatchCB();

                  this.handleSetVerificationData({
                    sessionId,
                    authType: type,
                    status: err.response.status,
                    verification_error: null,
                    changedWalletId: wallet_id,
                    validTill,
                    transport,
                  });
                  this.openSMSModal();
                } else if (
                  err.response.status === 400 &&
                  err.response.data.error.message.type === 'api.wallets.wrong_number'
                ) {
                  this.handleErrorAlerts(err.response);
                  this.setState(() => ({
                    smsModal: false,
                  }));
                  this.handleSetVerificationData({
                    ...deafaultVerifiationData,
                  });
                } else this.handleErrorAlerts(err.response);
              }
            }
          });
      },
    );
  };

  modalSubmit = code => {
    const { submitData, submitCatchCB, submitThenCB } = this.state;

    this.handleSubmitWithSMS({
      submitData,
      submitCatchCB,
      submitThenCB,
      code,
    });
  };

  handleSetVerificationData = verificationData =>
    this.setState(prevState => ({
      ...prevState,
      ...verificationData,
    }));

  selectPurse = wallet => {
    this.setState({ selectedWallet: wallet });
  };

  toggleSMSModal = () =>
    this.setState(({ smsModal }) => ({
      smsModal: !smsModal,
      sessionId: '',
      status: null,
      verification_error: null,
      validTill: 0,
    }));

  closeSMSModal = () => this.setState(() => ({ smsModal: false }));

  openSMSModal = () => this.setState({ smsModal: true });

  handleValidate = (regexp, number) => {
    if (Array.isArray(regexp) && regexp.length > 0) {
      const re = new RegExp(...regexp);
      if (number.search(re) === -1) {
        return true;
      }
    }
    return false;
  };

  getGrouppedWallets = wallets => {
    const { selectedWallet } = this.state;
    // if (selectedWallet === 15 || selectedWallet === 27) {
    //   return wallets.filter(wallet => wallet.type === 15 || wallet.type === 27);
    // } else {
    //   return wallets.filter(wallet => wallet.type === this.state.selectedWallet);
    // }
    return wallets.filter(wallet => wallet.type === this.state.selectedWallet);
  };

  render() {
    const { isMember, className, intl, clearRedirectToPaymentsData, profile, redirectToPaymentsData } = this.props;
    const {
      loading,
      modal,
      error,
      newWalletSMSInputTargetId,
      smsModal,
      selectedWallet,
      sessionId,
      verification_error,
      status,
      validTill,
      authType,
      transport,
    } = this.state;

    const wallets = this.getEditableWallets(this.getPropsWallets());

    return (
      <div className="payment-data">
        <Layout formattedTitle="pages.payment-data.title">
          <Col xs="12">
            <h3 className="page-title">
              <FormattedMessage
                id="navigation.sidebar.payments.data.title"
                defaultMessage="Requisite details"
              />
            </h3>
          </Col>
          <Col lg="4">
            <Card>
              <Card.Body>
                <ProfileCard />
              </Card.Body>
            </Card>
            <Card>
              <ProfileNav />
            </Card>
          </Col>
          <Col lg="8">
            <PaymentPursesNav
              selectedWallet={selectedWallet}
              selectPurse={this.selectPurse}
              wallets={wallets}
              // wallets={[...wallets.filter(wallet => !(wallet.title === 'WebMoney WMR'))]}
            />

            {wallets && (
              <PaymentPursesList
                theme={3}
                wallets={this.getGrouppedWallets(wallets)}
                loading={loading}
                onSavePurse={this.handleSave}
                onDeletePurse={this.handleDelete}
                // onEditCard={this.handleEdit}
                profile={profile}
                intl={intl}
                newWalletSMSInputTargetId={newWalletSMSInputTargetId}
                handleChangeNewWalletSMSInputTargetId={this.handleChangeNewWalletSMSInputTargetId}
                handleSubmitWithSMS={this.handleSubmitWithSMS}
                handleValidate={this.handleValidate}
                clearRedirectToPaymentsData={clearRedirectToPaymentsData}
                submitCatchCB={this.submitCatchCB}
                submitThenCB={this.submitThenCB}
                isMember={isMember}
                className={className}
                showAlert={this.props.showAlert}
                closeAlert={this.props.closeAlert}
                getWallets={this.getWallets}
                redirectToPaymentsData={redirectToPaymentsData}
              />
            )}
            <SMSNotificationsModal
              authType={authType}
              sessionId={sessionId}
              validTill={validTill}
              isOpen={smsModal}
              toggleModal={this.toggleSMSModal}
              onSubmit={(e, code) => this.modalSubmit(code)}
              error={verification_error}
              status={status}
              transport={transport}
            />

            {error.message && (
              <AlertModal open={modal} message={error.message} onClose={this.closeModal} />
            )}
          </Col>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = ({ webmaster, slaves, finances }) => ({
  wallets: webmaster.wallets,
  slaves: slaves,
  isSlave: webmaster.isSlave,
  redirectToPaymentsData: finances.redirectToPaymentsData,
  profile: webmaster.profile,
});

const mapDispatchToProps = dispatch => ({
  startSetWallets: params => dispatch(startSetWallets(params)),
  startSetSlaveWallets: params => dispatch(startSetSlaveWallets(params)),
  startCreateWallets: data => dispatch(startCreateWallets(data)),
  startCreateSlaveWallets: data => dispatch(startCreateSlaveWallets(data)),
  startDeleteWallets: params => dispatch(startDeleteWallets(params)),
  startDeleteSlaveWallets: params => dispatch(startDeleteSlaveWallets(params)),
  startUpdateWallets: data => dispatch(startUpdateWallets(data)),
  clearRedirectToPaymentsData: () => dispatch(clearRedirectToPaymentsData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(injectIntl(PaymentDataPage)));
